import React from 'react';

export const name = 'error';

export const Error = () => (
  <svg
    viewBox="0 0 18 18"
    color="#FF6242"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
      fill="currentColor"
    />
    <line x1="9" y1="4.5" x2="9" y2="10.5" stroke="white" strokeWidth="1.125" />
    <line x1="9" y1="12" x2="9" y2="13.5" stroke="white" strokeWidth="1.125" />
  </svg>
);
